import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import OtherProjects from './pages/OtherProjects';
import DevelopmentProjects from './pages/DevelopmentProjects';
// import { InkindFeaturePage } from '../inkind';
import { Events } from '../events';
import ProjectDetailsSwitcher from './details/ProjectDetailsSwitcher';
import ProjectsSwitcher from './pages/ProjectsSwticher';

const DevelopmentProjectDetails = lazy(() => import('./details/DevelopmentProjectDetails'));
const PortalProjectDetails = lazy(() => import('./details/PortalProjectDetails'));
const InkindFeaturePage = lazy(() =>
  import('../inkind').then((module) => ({ default: module.InkindFeaturePage })),
);

const routes: RouteObject[] = [
  {
    path: '',
    index: true,
    element: <ProjectsSwitcher />,
  },
  {
    path: 'in-projects',
    handle: { crumbs: ['inFinancedProjects'] },
    element: <DevelopmentProjects />,
  },
  {
    path: 'own-projects',
    handle: { crumbs: ['ownProjects'] },
    element: <OtherProjects />,
  },
  {
    path: 'inkind',
    handle: { crumbs: ['selfEffort'] },
    element: <InkindFeaturePage />,
  },
  {
    path: 'events/*',
    handle: { crumbs: ['allEvents'] },
    element: <Events />,
  },
  {
    path: 'details/:projectId/*',
    element: <ProjectDetailsSwitcher />,
  },
  {
    path: 'own-projects/:projectId/*',
    handle: { crumbs: ['ownProjects'] },
    element: <PortalProjectDetails />,
  },
  {
    path: 'in-projects/:projectId/*',
    handle: { crumbs: ['inFinancedProjects'] },
    element: <DevelopmentProjectDetails />,
  },
];

export default routes;
